// extracted by mini-css-extract-plugin
export default {"content":"styles_content__yeyup","title":"styles_title__PBWOM","articles":"styles_articles__bnVPI"};